import Modal from '../Modal/Modal';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Typography, DatePicker, DatePickerProps } from 'antd';
import styles from './DownloadModal.module.less';
import { Button } from '../Button/Button';
import { RangePickerValue } from '../../types/RangePickerValue';

export type DownloadModalProps = {
  onClose: () => void;
  onSubmit: (start: Date, end: Date) => void;
  visible: boolean;
};

export const disabledDate: DatePickerProps['disabledDate'] = current => {
  return Boolean(current && current.endOf('day').toDate() >= new Date());
};

export const DownloadModal = (props: DownloadModalProps) => {
  const { onClose, visible, onSubmit } = props;
  const { t } = useTranslation();
  const [dates, setDates] = useState<RangePickerValue>();

  const onDateChange = useCallback(
    (dates: RangePickerValue) => {
      setDates(dates);
    },
    [setDates]
  );
  const onDownloadClick = useCallback(() => {
    const [startDateMoment, endDateMoment] = dates || [];
    if (startDateMoment && endDateMoment) {
      onSubmit(startDateMoment.toDate(), endDateMoment.toDate());
    }
  }, [dates]);
  return (
    <Modal
      width={484}
      className={styles.modal}
      titleText={t('modal.download.title')}
      visible={visible}
      onClose={onClose}
      footer={
        <Row justify="space-between">
          <Col xs={11}>
            <Button block onClick={onClose}>
              {t('general.cancel')}
            </Button>
          </Col>
          <Col xs={11}>
            <Button
              type="primary"
              block
              onClick={onDownloadClick}
              disabled={dates?.length !== 2}
              data-testid="downloadButton"
            >
              {t('modal.download.downloadButton')}
            </Button>
          </Col>
        </Row>
      }
    >
      <div>
        <div>
          <Typography.Text>{t('modal.download.text')}</Typography.Text>
        </div>
        <div className={styles.rangePicker}>
          <DatePicker.RangePicker onChange={onDateChange} disabledDate={disabledDate} />
        </div>
      </div>
    </Modal>
  );
};

export default DownloadModal;
